/* eslint-disable @typescript-eslint/naming-convention */
import type { WizardComponentsMap } from '@lemonade-hq/chat-wizard-client-base';
import type { UniclientComponent } from '@lemonade-hq/uniclient-chat';
import { WizardPageAdapter } from './WizardPageAdapter';

export const COMPONENT_ID = 'wizard-component';

export const COMPONENTS_MAP: WizardComponentsMap<UniclientComponent<string>['type']> = {
  accordion: async () => (await import('./WizardAccordionAdapter')).WizardAccordionAdapter,
  selectable_cards: async () => (await import('./WizardSelectableCardsAdapter')).WizardSelectableCardsAdapter,
  illustrated_cards: async () => (await import('./WizardIllustratedCardsAdapter')).WizardIllustratedCardsAdapter,
  form: async () => (await import('./WizardFormAdapter')).WizardFormAdapter,
  inlineForm: async () => (await import('./WizardInlineFormAdapter')).WizardInlineFormAdapter,
  content: async () => (await import('./WizardContentAdapter')).WizardContentAdapter,
  image: async () => (await import('./WizardImageAdapter')).WizardImageAdapter,
  sticker: async () => (await import('./WizardStickerAdapter')).WizardStickerAdapter,
  otp: async () => (await import('./WizardOtpAdapter')).WizardOtpAdapter,
  analysis: async () => (await import('./WizardAnalysisAdapter')).WizardAnalysisAdapter,
  page: async () => await Promise.resolve(WizardPageAdapter),
  price: async () => (await import('./WizardPriceAdapter')).WizardPriceAdapter,
  price_card: async () => (await import('./WizardPriceCardAdapter')).WizardPriceCardAdapter,
  productSummary: async () => (await import('./WizardProductSummaryAdapter')).WizardProductSummaryAdapter,
  grid: async () => (await import('./WizardGridAdapter')).WizardGridAdapter,
  list: async () => (await import('./WizardListAdapter')).WizardListAdapter,
  checkout: async () => (await import('./WizardCheckoutAdapter')).WizardCheckoutAdapter,
  cart: async () => (await import('./WizardCartAdapter')).WizardCartAdapter,
  product_card: async () => (await import('./WizardProductCardAdapter')).WizardProductCardAdapter,
  dynamic_list: async () => (await import('./WizardDynamicListAdapter')).WizardDynamicListAdapter,
  specialFx: async () => (await import('./WizardSpecialFxAdapter')).WizardSpecialFxAdapter,
  selectable: async () => (await import('./WizardSelectableAdapter')).WizardSelectableAdapter,
  progress_card: async () => (await import('./WizardProgressCardAdapter')).WizardProgressCardAdapter,
  realtime: async () => (await import('./WizardRealtimeAdapter')).WizardRealtimeAdapter,
  input_cards: async () => (await import('./WizardInputCardsAdapter')).WizardInputCardsAdapter,
  update_payment: async () => (await import('./WizardUpdatePaymentAdapter')).WizardUpdatePaymentAdapter,
  photo_collection: async () => (await import('./WizardPhotoCollectionAdapter')).WizardPhotoCollectionAdapter,
  canopy: async () => (await import('./WizardCanopyAdapter')).WizardCanopyAdapter,
};
